import { ApplicationConfig, ApplicationSection, FieldType } from '@bybeam/platform-types';

const SECTIONS: ApplicationSection[] = [
  {
    key: 'learnMore',
    name: 'KC BizCare',
    overview: {
      description: 'Learn more about this program',
      title: 'KC BizCare',
    },
    questionGroups: [
      {
        key: 'learnMore',
        name: 'KC BizCare',
        questions: [
          {
            key: 'link',
            copy: { title: 'KC BizCare' },
            layout: 'panel',
            fields: [
              {
                key: 'link',
                type: FieldType.Typography,
                copy: `
The City of Kansas City, Missouri office for small business, KC BizCare is a free business resource, advocacy and information center for new and existing businesses operating within the city. Since our establishment in 2009, our office has supported thousands of entrepreneurs.

KC BizCare can assist with: 
- Business registration (federal, state, city)
- Obtaining a KCMO business license
- Submit a zoning clearance
- Navigating requirements for required permits
- Resource referrals into the small business ecosystem

To learn more, visit [https://bizcare.kcmo.gov](https://bizcare.kcmo.gov) or call [816-513-2491](tel:8165132491). 
                `,
                props: { variant: 'largeBody', alignment: 'left' },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'attestation',
    name: 'Attestation',
    overview: {
      title: 'Attestation',
      description: '',
    },
    questionGroups: [
      {
        key: 'attestation',
        name: 'Attestation',
        questions: [
          {
            key: 'attestation',
            copy: { title: 'Attestation' },
            layout: 'panel',
            fields: [
              {
                key: 'attestation.info',
                type: FieldType.Typography,
                copy: 'I understand that to apply for this program, I must visit the external site: [https://bizcare.kcmo.gov/](https://bizcare.kcmo.gov/)',
                props: { variant: 'largeBody', alignment: 'center' },
              },
              {
                key: 'attestation.confirm',
                type: FieldType.Checkbox,
                copy: 'I confirm.',
              },
            ],
          },
        ],
      },
    ],
  },
];

const CONFIG: ApplicationConfig = {
  introPages: [],
  overrides: {
    statuses: [
      {
        status: 'Application',
        label: '',
        message:
          'This is an external program with its own application. To learn more & apply, visit [https://bizcare.kcmo.gov/](https://bizcare.kcmo.gov/).',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
      {
        status: 'InProgress',
        label: '',
        message:
          'This is an external program with its own application. To learn more & apply, visit [https://bizcare.kcmo.gov/](https://bizcare.kcmo.gov/).',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
    ],
    submission: {
      title: 'What happens next?',
      bullets: [
        {
          key: 'review',
          title: 'Application review',
          icon: 'description',
          description:
            'While we look at your application, we might send you an email to ask for more information or notify you of next steps',
        },
      ],
    },
  },
  sections: SECTIONS,
};

export default CONFIG;
